<template><ArchiveTerm kind="ask" /></template>
<script>
import ArchiveTerm from './ArchiveTerm.vue';
export default { name: 'AiAskTerm', components: { ArchiveTerm } };
</script>
